import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';
import ConfirmModal from '@mulesoft/exchange-ui-components/lib/components/ConfirmModal';
import Radio from '@mulesoft/anypoint-components/lib/Radio';
import RadioGroup from '@mulesoft/anypoint-components/lib/RadioGroup';
import { ScanConfigurationPropType } from '~/components/AgentScanners/types/commonTypes';
import styles from './DeleteConfirmModal.css';

const DeleteConfirmModal = ({ scanConfig, onCancel, onConfirm }) => {
  const [deleteOption, setDeleteOption] = useState('false');

  const handleConfirm = useCallback(() => {
    onConfirm(deleteOption);
  }, [onConfirm, deleteOption]);

  const onChangeDeleteOption = useCallback((value) => {
    setDeleteOption(value);
  }, []);

  return (
    <ConfirmModal
      title="Delete scanner?"
      confirmButtonText="Delete"
      cancelButtonText="Cancel"
      onCancel={onCancel}
      onConfirm={handleConfirm}
      body={
        <div className={styles.deleteModal}>
          <p>
            Deleting {scanConfig.name} agent scanner stops automatic agent
            discovery and updates.
          </p>
          <p>Select an option for imported agents</p>
          <RadioGroup
            id="delete-options"
            name="deleteOptions"
            testId="delete-options"
            value={deleteOption}
            orientation="vertical"
            onChange={(event) => onChangeDeleteOption(event.value)}
          >
            <Radio
              testId="delete-options-false"
              label="Keep imported agents in Exchange"
              value="false"
              className={styles.deleteModalItem}
            />
            <Radio
              testId="delete-options-true"
              label="Delete agents from Exchange"
              value="true"
              className={styles.deleteModalItem}
            />
          </RadioGroup>
        </div>
      }
    />
  );
};

DeleteConfirmModal.propTypes = {
  scanConfig: ScanConfigurationPropType,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default DeleteConfirmModal;
